<!-- eslint-disable -->
<template>
  <div class="container py-3 card bg-white">


    <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 p-4">
      <!--      <div class="col-md-3">
              <input
                  v-model="query.keyword"
                  type="text"
                  class="form-control"
                  placeholder="Имя"
                  @input="handleFilter"
                  @keyup.enter="handleFilter"
              />
            </div>-->

      <div class="col-md-3">
        <select
            v-model="query.role"
            class="form-control"
            @change="handleFilter"
        >
          <option value="" selected>Выберите роль</option>
          <option v-for="item in roles" :key="item" :value="item">
            {{ item }}
          </option>
        </select>
      </div>

      <div class="col-md-3">
        <select
            v-model="query.status"
            class="form-control"
            @change="handleFilter"
        >
          <option value="" selected>Статус работы</option>
          <option v-for="(item, index) in statuses" :key="item" :value="item">
            {{ item }}
          </option>
        </select>
      </div>

      <RouterLink to="/users/create"
                  class="btn btn-outline-primary  px-sm-4 fs-14 fw-medium rounded-3 hover-bg">
                                    <span class="py-sm-1 d-block">
                                        <i class="ri-add-line d-none d-sm-inline-block"></i>
                                        <span>
                                         Добавить пользователя
                                        </span>
                                    </span>
      </RouterLink>
    </div>

    <div v-if="deleteAlert.visible" class="custom-alert">
      <div class="alert-content">
        <p class="alert-message">Подтвердите удаление</p>
        <div class="alert-buttons">
          <button
              type="button"
              class="btn btn-danger confirm-button"
              @click="confirmDelete"
          >
            Подтвердить
          </button>
          <button
              type="button"
              class="btn btn-secondary cancel-button"
              @click="cancelDelete"
          >
            Отменить
          </button>
        </div>
      </div>
    </div>

    <div v-if="retireAlert.visible" class="custom-alert">
      <div class="alert-content">
        <p class="alert-message">Подтвердите увольнение</p>
        <div class="alert-buttons">
          <button
              type="button"
              class="btn btn-danger confirm-button"
              @click="confirmRetire"
          >
            Подтвердить
          </button>
          <button
              type="button"
              class="btn btn-secondary cancel-button"
              @click="cancelRetire"
          >
            Отменить
          </button>
        </div>
      </div>
    </div>

    <div class="default-table-area style-two all-projects">
      <div class="table-responsive">
        <table class="table table-bordered table-striped- table-hover align-middle">
          <thead class="table-light">
          <tr>
            <th style="width: 70px;">#</th>
            <th>Роль</th>
            <th style="width: 200px;">Пользователь</th>
            <th>Номер телефона</th>
            <th>Дата</th>
            <!--            <th>Песель\номер паспорта</th>-->
            <th>Действия</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(row, index) in list" :key="row.id">
            <td style="width: 70px;">{{ index + 1 }}</td>
            <td>
              {{ trans(row.roles[0]) }}
              <br/>
              <small v-if="row.roles[0] === 'coordinator'">
                Главный координатор: {{ row.ownerName }}
              </small>
            </td>
            <td style="width: 200px;">{{ row.name }}</td>
            <td>{{ row.phone }}</td>
            <!--            <td>{{ row.pesel }} \ {{ row.passport }}</td>-->
            <td>{{ row.created_at }}</td>
            <td class="actions-column">

              <a class="ps-0 border-0 bg-transparent lh-1 position-relative top-2"
                 :href="`/users/edit/${row.id}`">
                <i class="material-symbols-outlined fs-16 text-body">edit</i>
              </a>

              <button class="ps-0 border-0 bg-transparent lh-1 position-relative top-2"
                      v-if="userRole !== 'manager'"
                      @click="showDeleteConfirmation(row)">
                <i class="material-symbols-outlined fs-16 text-danger" title="Удалить">delete</i>
              </button>

              <button class="ps-0 border-0 bg-transparent lh-1 position-relative top-2"
                      v-if="userRole.includes('grand_admin') && row.id !== 1 && !row.retired_at"
                      title="Уволить"
                      @click="showRetireConfirmation(row)"
              >
                <i class="material-symbols-outlined fs-16 text-warning" title="Уволить">delete</i>
              </button>

              <span v-if="row.retired_at">(уволен)</span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Custom Pagination -->
  </div>
</template>


<!--    <el-dialog :close-on-click-modal="false" :title="'Создать нового пользователя'" :visible.sync="dialogFormVisible">
      <div v-loading="userCreating" class="form-container">
        <el-form ref="userForm" :rules="rules" :model="newUser" label-position="left" label-width="170px"
                 style="max-width: 500px;">
          <el-form-item label="роль" prop="role"
                        v-if="userRole.includes('grand_admin') || userRole.includes('admin')">
            <el-select v-model="newUser.role" class="filter-item" placeholder="Выберите роль">
              <el-option v-for="item in rolesForAdmin" :key="item" :label="item" :value="item"/>
            </el-select>
          </el-form-item>
          <el-form-item label="роль" prop="role" v-if="userRole.includes('manager')">
            <el-select v-model="newUser.role" class="filter-item" placeholder="Выберите роль">
              <el-option v-for="item in rolesForManager" :key="item" :label="item" :value="item"/>
            </el-select>
          </el-form-item>
          <el-form-item label="роль" prop="role" v-if="userRole.includes('coordinator_main')">
            <el-select v-model="newUser.role" class="filter-item" placeholder="Выберите роль" style="width: 100%;">
              <el-option v-for="item in rolesForCoordinatorMain" :key="item" :label="item" :value="item"/>
            </el-select>
          </el-form-item>
          <el-form-item label="Имя и фамилия" prop="name">
            <el-input v-model="newUser.name"/>
          </el-form-item>
          <el-form-item label="Главный координатор" prop="owner_id"
                        v-if="userRole.includes('manager') && newUser.role==='Координатор'">
            <el-select v-model="newUser.ownerId" class="filter-item" placeholder="Выберите главного координатора"
                       style="width: 100%;">
              <el-option v-for="item in list" :key="item.id" :label="item.name" :value="item.id"
                         v-if="item.roles[0]==='coordinator_main'"/>
            </el-select>
          </el-form-item>
          <el-form-item label="Логин" prop="username">
            <el-input v-model="newUser.username"/>
          </el-form-item>
          <el-form-item label="Пароль" prop="password">
            <el-input v-model="newUser.password"/>
          </el-form-item>
          <el-form-item label="Подтвердить пароль" prop="confirmPassword">
            <el-input v-model="newUser.confirmPassword"/>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">
           Отменить
          </el-button>
          <el-button type="primary" @click="createUser()">
          Подтвердить
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" title="Часы" :visible.sync="dialogHoursVisible" width="50%">
      <el-row>
        <div class="calendar">
          <div class="header">
            <div class="day" v-for="day in daysOfWeek" :key="day">{{ day }}</div>
          </div>
          <div class="month-controls">
            <button @click="prevMonth">Назад</button>
            <span>{{ monthNames[currentMonth] }} {{ currentYear }}</span>
            <button @click="nextMonth">Вперед</button>
          </div>
          <div class="grid">
            <div class="cell" v-for="(cell, index) in calendarCells" :key="index">
              <div v-if="cell.date" class="date">{{ cell.date }}</div>
              <input v-if="cell.date" type="time" v-model="cell.startTime" @change="calculateTotalWorkingHours()"
                     class="start-time" placeholder="Start Time">
              <input v-if="cell.date" type="time" v-model="cell.endTime" @change="calculateTotalWorkingHours()"
                     class="end-time" placeholder="End Time">
            </div>
          </div>
          <div class="footer">
            <div class="footer-text">
              Всего часов в текущем месяце: {{ totalHoursUser }}
            </div>
            <div class="footer-button">
              <button @click="saveCalendarNew">Сохранить часы (текущий месяц)</button>
            </div>
          </div>
        </div>
      </el-row>
    </el-dialog>-->


<script>
import UserResource from '@/api/user';
import Resource from '@/api/resource';
import {saveCalendar} from '@/api/actualization';
import {deleteVacancy} from "@/api/vacancy";

const userResource = new UserResource();
const permissionResource = new Resource('permissions');

export default {
  name: 'UserList',
  data() {
    var validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.newUser.password) {
        callback(new Error('Пароли не совпдают'));
      } else {
        callback();
      }
    };
    return {
      isFromReports: 0,
      deleteAlert: {
        visible: false,
        row: null,
      },
      retireAlert: {
        visible: false,
        row: null,
      },
      downloadLoading: false,
      userCalendar: [],
      userCalendarForUser: 0,
      totalHoursUser: 0,
      daysOfWeek: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
      monthNames: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
      calendarCells: [],
      currentMonth: new Date().getMonth(),
      currentYear: new Date().getFullYear(),
      workedHours: [],
      list: null,
      total: 0,
      totalHours: [],
      loading: true,
      downloading: false,
      userCreating: false,
      query: {
        page: 1,
        limit: 500,
        keyword: '',
        role: null,
        status: 'Работает',
      },
      statuses: ['Работает', 'Не работает',],
      roles: ['Гранд Админ', 'Админ', 'Наблюдатель', 'Координатор', 'Рекрутер Ś/U', 'Рекрутер ZL', 'Менеджер', 'Главный координатор'],
      rolesForAdmin: ['Админ', 'Наблюдатель', 'Координатор', 'Рекрутер Ś/U', 'Рекрутер ZL', 'Менеджер', 'Главный координатор'],
      rolesForManager: ['Координатор', 'Рекрутер Ś/U', 'Рекрутер ZL', 'Главный координатор'],
      rolesForCoordinatorMain: ['Координатор'],
      newUser: {
        username: this.generateUsername()
      },
      dialogHoursVisible: false,
      dialogFormVisible: false,
      dialogPermissionVisible: false,
      dialogPermissionLoading: false,
      currentUserId: 0,
      currentUser: {
        name: '',
        permissions: [],
        rolePermissions: [],
      },
      rules: {
        role: [{required: true, message: 'Роль обязательна', trigger: 'change'}],
        name: [{required: true, message: 'Имя обязательно', trigger: 'blur'}],
        username: [{required: true, message: 'Логин обязателен', trigger: 'blur'}],
        password: [{required: true, message: 'Пароль обязателен', trigger: 'blur'}],
        confirmPassword: [{required: true, validator: validateConfirmPassword, trigger: 'blur'}],
      },
      permissionProps: {
        children: 'children',
        label: 'name',
        disabled: false,
      },
      permissions: [],
      menuPermissions: [],
      otherPermissions: [],
      randomPassword: '',
    };
  },
  created() {
    this.isFromReports = this.$route.query.is_from_reports === '1';
    this.parseRoleFromUrl();
    this.resetNewUser();
    this.loadSearchTerm();
    this.startStoragePolling(); // Start polling local storage
    this.getList();
    /*  if (checkPermission(['permission manage'])) {
        this.getPermissions();
      }*/
  },
  methods: {
    loadSearchTerm() {
      this.query.keyword = localStorage.getItem("searchTerm") || ""; // Load from local storage
    },
    handleStorageChange(event) {
      if (event.key === "searchTerm") {
        this.searchTerm = event.newValue; // Update search term when local storage changes
        this.getList();
      }
    },
    startStoragePolling() {
      // Poll local storage for changes every 500ms
      this.storagePollingInterval = setInterval(() => {
        const currentSearchTerm = localStorage.getItem("searchTerm") || "";
        if (currentSearchTerm !== this.query.keyword) {
          this.query.keyword = currentSearchTerm; // Update search term
          this.getList(); // Perform search
        }
      }, 500);
    },
    stopStoragePolling() {
      // Clear the polling interval
      if (this.storagePollingInterval) {
        clearInterval(this.storagePollingInterval);
      }
    },
    handleFilter() {
      this.query.page = 1;
      this.getList();
    },
    generateUsername(length = 8) {
      return 'hr-' + [...Array(length)].map(() => 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz123456789'[Math.floor(Math.random() * 61)]).join('');
    },
    sortChange(data) {
      const {prop, order} = data;
      this.sortBy(prop, order);
    },
    sortBy(prop, order) {
      if (order === 'ascending') {
        this.query.sort = '+' + prop;
      } else {
        this.query.sort = '-' + prop;
      }
      this.handleFilter();
    },
    getNestedValue(obj, path) {
      return path.split('.').reduce((o, i) => (o ? o[i] : ''), obj);
    },
    generateCalendar() {
      console.log(this.userCalendar);
      console.log(this.userCalendarForUser);

      const firstDayOfMonth = new Date(this.currentYear, this.currentMonth, 1);
      const lastDayOfMonth = new Date(this.currentYear, this.currentMonth + 1, 0);

      // Calculate the starting position of the calendar (offset by the first day of the month)
      const startOffset = firstDayOfMonth.getDay();

      // Create empty cells for the days before the start of the month
      this.calendarCells = [];
      for (let i = 0; i < startOffset; i++) {
        this.calendarCells.push({}); // Empty cell
      }

      // Create cells for each day of the month
      for (let day = 1; day <= lastDayOfMonth.getDate(); day++) {
        // Initialize the cell with default values
        let cell = {
          userId: this.userCalendarForUser,
          date: day,
          month: this.currentMonth + 1,
          year: this.currentYear,
          startTime: '',
          endTime: ''
        };

        // Check if there are any events for this day
        const dateStr = `${this.currentYear}-${String(this.currentMonth + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
        const event = this.userCalendar.find(event => event.date === dateStr);

        // If an event is found, update the startTime and endTime
        if (event) {
          cell.startTime = event.start_time;
          cell.endTime = event.end_time;
        }

        // Add the cell to the calendar
        this.calendarCells.push(cell);
      }

      for (let day = 1; day <= lastDayOfMonth.getDate() + 1; day++) {
        this.calculateTotalWorkingHours();
      }
    },
    prevMonth() {
      if (this.currentMonth === 0) {
        this.currentMonth = 11;
        this.currentYear--;
      } else {
        this.currentMonth--;
      }
      this.generateCalendar();
    },
    nextMonth() {
      if (this.currentMonth === 11) {
        this.currentMonth = 0;
        this.currentYear++;
      } else {
        this.currentMonth++;
      }
      this.generateCalendar();
    },
    calculateTotalWorkingHours() {
      // Initialize the total working hours variable
      let totalWorkingHours = 0;

      console.log('Starting calculation of total working hours.');
      console.log('Calendar cells:', this.calendarCells);
      console.log('Number of calendar cells:', this.calendarCells.length);

      // Calculate the working hours for each cell
      for (const cell of this.calendarCells) {
        if (cell.startTime && cell.endTime) {
          try {
            const start = new Date(`${cell.year}-${String(cell.month).padStart(2, '0')}-${String(cell.date).padStart(2, '0')}T${cell.startTime}`);
            const end = new Date(`${cell.year}-${String(cell.month).padStart(2, '0')}-${String(cell.date).padStart(2, '0')}T${cell.endTime}`);

            // Check if the end time is after the start time
            if (end > start) {
              const hoursWorked = (end - start) / (1000 * 60 * 60); // Difference in hours

              // Log the details for each day
              console.log(`Date: ${cell.date}-${cell.month}-${cell.year}`);
              console.log(`Start Time: ${cell.startTime}`);
              console.log(`End Time: ${cell.endTime}`);
              console.log(`Hours Worked: ${hoursWorked.toFixed(2)}`);
              console.log('---');

              // Add to the total working hours
              totalWorkingHours += hoursWorked;
            } else {
              //console.warn(`Invalid time range for ${cell.date}-${cell.month}-${cell.year}: startTime (${cell.startTime}) is after endTime (${cell.endTime})`);
            }
          } catch (error) {
            //console.error(`Error parsing dates for ${cell.date}-${cell.month}-${cell.year}:`, error);
          }
        } else {
          //console.debug(`Missing startTime or endTime for ${cell.date}-${cell.month}-${cell.year}`);
        }
      }

      this.totalHoursUser = Math.floor(totalWorkingHours);
      console.log('Total working hours calculated:', totalWorkingHours);
    },
    async getList() {
      const {limit, page} = this.query;
      this.loading = true;
      const {data, meta} = await userResource.list(this.query);
      this.list = data;
      this.list.forEach((element, index) => {
        element['index'] = (page - 1) * limit + index + 1;
      });
      this.total = meta.total;
      this.loading = false;
    },
    async getListUpdate() {
      const {data, meta} = await userResource.list(this.query);
      this.list = data;
    },

    /*    calculateTotalHoursForMonth(calendar, userId) {
          const now = new Date();
          const year = now.getFullYear();
          const month = now.getMonth();
          const firstDayOfMonth = new Date(year, month, 1);
          const lastDayOfMonth = new Date(year, month + 1, 0);
          let totalHours = 0;

          // Filter calendar entries for the specified user within the current month
          const entries = calendar.filter(entry => {
            const entryDate = new Date(entry.date);
            return entry.user_id === userId &&
              entryDate >= firstDayOfMonth &&
              entryDate <= lastDayOfMonth &&
              entry.start_time && entry.end_time;
          });


          entries.forEach(entry => {
            const {start_time, end_time} = entry;
            if (start_time && end_time) {
              try {
                // Ensure times are in 'HH:mm' format and parse them correctly
                const [startHour, startMinute] = start_time.split(':').map(Number);
                const [endHour, endMinute] = end_time.split(':').map(Number);

                // Ensure that both start and end time are valid
                if (isNaN(startHour) || isNaN(startMinute) || isNaN(endHour) || isNaN(endMinute)) {
                  console.error(`Invalid time format for entry: ${entry}`);
                  return;
                }

                const startDateTime = new Date(`${entry.date}T${start_time}`);
                const endDateTime = new Date(`${entry.date}T${end_time}`);

                // Ensure that startDateTime is before endDateTime
                if (startDateTime >= endDateTime) {
                  console.error(`Start time is not before end time for entry: ${entry}`);
                  return;
                }

                const diffMillis = endDateTime - startDateTime;
                const diffHours = diffMillis / (1000 * 60 * 60);
                totalHours += diffHours;
              } catch (error) {
                console.error(`Error calculating hours for entry: ${entry}`, error);
              }
            }
          });

          // Return total hours rounded to two decimal places
          return Math.round(totalHours * 100) / 100;
        },*/

    onDateChange(calendar, date, id) {
      this.$nextTick(() => {
        const existingEntry = this.findCalendarEntry(calendar, date, id);
        if (existingEntry) {
          this.$set(calendar, 'start_time', existingEntry.start_time);
          this.$set(calendar, 'end_time', existingEntry.end_time);
        } else {
          this.$set(calendar, 'start_time', null);
          this.$set(calendar, 'end_time', null);
        }
      });

      //console.log(`Total hours worked in the month: ${totalHours} hours`);
      //this.totalHours[id] = this.calculateTotalHoursForMonth(calendar, id);

    },

    getWorkedHours(userId, date) {
      if (date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const formattedMonth = `${year}-${month}`;
        return this.workedHours[userId] && this.workedHours[userId][formattedMonth] || 0;
      } else {
        return null;
      }
    },

    formatDate(date) {
      const adjustedDate = new Date(date);
      adjustedDate.setUTCDate(adjustedDate.getUTCDate() + 1);
      return adjustedDate.toISOString().slice(0, 10);
    },

    findCalendarEntry(calendar, date, id) {
      const formattedDate = this.formatDate(date);
      return calendar.find(entry => entry.date === formattedDate && entry.user_id === id);
    },

    calculateTotalWorkedHours(calendar, formattedDate) {
      // Extract year and month from formattedDate
      const [year, month] = formattedDate.split('-');

      let totalHours = 0;

      // Iterate over each entry in the calendar
      calendar.forEach(entry => {
        // Split the date of the entry to get year and month
        const [entryYear, entryMonth] = entry.date.split('-');

        // Check if the entry is within the same year and month
        if (entryYear === year && entryMonth === month && entry.start_time && entry.end_time) {
          // Parse the start and end times
          const startTime = new Date(`1970-01-01T${entry.start_time}Z`);
          const endTime = new Date(`1970-01-01T${entry.end_time}Z`);

          // Calculate the difference in hours
          const diffInHours = (endTime - startTime) / (1000 * 60 * 60);

          // Add to the total hours
          totalHours += diffInHours;
        }
      });

      // Round the final total hours to the nearest whole number
      return Math.round(totalHours);
    },
    saveWorkHoursOnDateChange(userId, calendar) {
      const selectedDate = calendar.date;
      const selectedStart = calendar.start_time;
      const selectedEnd = calendar.end_time;

      const year = selectedDate.getFullYear();
      const month = String(selectedDate.getMonth() + 1).padStart(2, '0');
      const day = String(selectedDate.getDate()).padStart(2, '0');
      const formattedDate = `${year}-${month}-${day}`;
      const formattedMonth = `${year}-${month}`;

      const totalWorkedHours = this.calculateTotalWorkedHours(calendar, formattedDate);
      console.log("Total Worked Hours:", totalWorkedHours);

      if (!this.workedHours[userId]) {
        this.$set(this.workedHours, userId, {});
      }
      this.$set(this.workedHours[userId], formattedMonth, totalWorkedHours);
    },
    saveCalendarNew() {
      saveCalendar(this.calendarCells).then(() => {
        window.location.reload();
      });
    },

    saveWorkHours(userId, calendar) {

      const selectedDate = calendar.date;
      const selectedStart = calendar.start_time;
      const selectedEnd = calendar.end_time;

      const year = selectedDate.getFullYear();
      const month = String(selectedDate.getMonth() + 1).padStart(2, '0');
      const day = String(selectedDate.getDate()).padStart(2, '0');
      const formattedDate = `${year}-${month}-${day}`;
      const formattedMonth = `${year}-${month}`;

      // Collect data and send to backend
      const dataToSend = {
        user_id: userId,
        date: selectedDate || '',
        start_time: selectedStart || '',
        end_time: selectedEnd || ''
      };

      const calendarEntry = calendar.find(entry => entry.date === formattedDate);

      // If a matching date is found, update the start_time and end_time
      if (calendarEntry) {
        calendarEntry.start_time = selectedStart;
        calendarEntry.end_time = selectedEnd
      } else {
        const newEntry = {
          date: formattedDate,
          start_time: selectedStart,
          end_time: selectedEnd,
          user_id: userId
        };
        calendar.push(newEntry);
      }

      console.log(calendar);
      const totalWorkedHours = this.calculateTotalWorkedHours(calendar, formattedDate);
      console.log("Total Worked Hours:", totalWorkedHours);


      if (!this.workedHours[userId]) {
        this.$set(this.workedHours, userId, {});
      }
      this.$set(this.workedHours[userId], formattedMonth, totalWorkedHours);

      saveCalendar(dataToSend).then(() => {
        //this.getListUpdate();
        // this.$notify({
        //   title: 'Успешно',
        //   message: 'Успешно',
        //   type: 'success',
        //   duration: 2000,
        // });
        //window.location.reload();
      });
      // console.log(dataToSend);
    },
    openHoursModal(user_id, calendar) {
      console.log(calendar);
      this.userCalendar = calendar;
      this.userCalendarForUser = user_id;
      this.generateCalendar();
      this.dialogHoursVisible = true;
    },
    parseRoleFromUrl() {
      let roleInt;
      const path = this.$route.path;
      const regex = /role(\d+)/;
      const match = path.match(regex);
      if (match && match[1]) {
        roleInt = parseInt(match[1]);
      } else {
        roleInt = parseInt(this.$route.query.role) || null;
      }
      if (roleInt === 1) {
        this.query.role = 'Гранд Админ';
      } else if (roleInt === 2) {
        this.query.role = 'Наблюдатель';
      } else if (roleInt === 3) {
        this.query.role = 'Админ';
      } else if (roleInt === 4) {
        this.query.role = 'Админ';
      } else if (roleInt === 5) {
        this.query.role = 'Рекрутер Ś/U';
      } else if (roleInt === 6) {
        this.query.role = 'Рекрутер ZL';
      }

      if (this.query.role) {
        this.getList()
      }
    },
    trans(item) {
      if (item === 'recruiter_zl') {
        return 'Рекрутер ZL'
      } else if (item === 'recruiter_su') {
        return 'Рекрутер SU'
      } else if (item === 'coordinator') {
        return 'Координатор'
      } else if (item === 'manager') {
        return 'Менеджер'
      }
      return item
    },
    async getPermissions() {
      const {data} = await permissionResource.list({});
      const {all, menu, other} = this.classifyPermissions(data);
      this.permissions = all;
      this.menuPermissions = menu;
      this.otherPermissions = other;
    },
    handleCreate() {
      this.resetNewUser();
      this.dialogFormVisible = true;
      this.randomPassword = this.generateRandomPassword(8)
      this.newUser.password = this.randomPassword
      this.newUser.confirmPassword = this.randomPassword
      this.$nextTick(() => {
        this.$refs['userForm'].clearValidate();
      });
    },
    generateRandomPassword(length) {
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+`|:?>';
      let result = '';
      const charactersLength = characters.length;
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    },
    async handleEditPermissions(id) {
      this.currentUserId = id;
      this.dialogPermissionLoading = true;
      this.dialogPermissionVisible = true;
      const found = this.list.find(user => user.id === id);
      const {data} = await userResource.permissions(id);
      this.currentUser = {
        id: found.id,
        name: found.name,
        permissions: data,
      };
      this.dialogPermissionLoading = false;
      this.$nextTick(() => {
        this.$refs.menuPermissions.setCheckedKeys(this.permissionKeys(this.userMenuPermissions));
        this.$refs.otherPermissions.setCheckedKeys(this.permissionKeys(this.userOtherPermissions));
      });
    },
    showDeleteConfirmation(row) {
      this.deleteAlert.row = row;
      this.deleteAlert.visible = true;
    },
    showRetireConfirmation(row) {
      this.retireAlert.row = row;
      this.retireAlert.visible = true;
    },
    confirmDelete() {
      const row = this.deleteAlert.row;
      if (row) {
        userResource.destroy(row.id).then(() => {
          const index = this.list.indexOf(row);
          this.list.splice(index, 1);
          this.cancelDelete();
        });
      }
    },
    confirmRetire() {
      const row = this.retireAlert.row;
      if (row) {
        userResource.retire(row.id).then(response => {
          const index = this.list.indexOf(row);
          this.list.splice(index, 1);
          this.cancelRetire();
        })
      }
    },
    cancelDelete() {
      this.deleteAlert.visible = false;
      this.deleteAlert.row = null;
    },
    cancelRetire() {
      this.retireAlert.visible = false;
      this.retireAlert.row = null;
    },
    createUser() {
      // this.$refs['userForm'].validate((valid) => {
      if (true) {
        this.newUser.roles = [this.newUser.role];
        this.userCreating = true;
        userResource
            .store(this.newUser)
            .catch(error => {
              console.log(error);
            })
            .finally(() => {
              this.userCreating = false;
            });
      } else {
        console.log('error submit!!');
        return false;
      }
      //   });
    },
    resetNewUser() {
      this.newUser = {
        name: '',
        username: this.generateUsername(),
        password: '',
        confirmPassword: '',
        role: '',
      };
    },
    handleDownload() {
      /*  this.downloading = true;
        import('@/vendor/Export2Excel').then(excel => {
          const tHeader = ['Имя', 'Логин'];
          const filterVal = ['name', 'username'];
          const data = this.formatJson(filterVal, this.list);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: 'user-list',
          });
          this.downloading = false;
        });*/
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    permissionKeys(permissions) {
      return permissions.map(permssion => permssion.id);
    },
    classifyPermissions(permissions) {
      const all = [];
      const menu = [];
      const other = [];
      permissions.forEach(permission => {
        const permissionName = permission.name;
        all.push(permission);
        if (permissionName.startsWith('view menu')) {
          menu.push(this.normalizeMenuPermission(permission));
        } else {
          other.push(this.normalizePermission(permission));
        }
      });
      return {all, menu, other};
    },

    normalizeMenuPermission(permission) {
      return {
        id: permission.id,
        name: permission.name,
        disabled: permission.disabled || false
      };
    },

    normalizePermission(permission) {
      const disabled = false;
      //const disabled = permission.disabled || permission.name === 'permission manage';
      return {id: permission.id, name: permission.name, disabled: disabled};
    },

    confirmPermission() {
      const checkedMenu = this.$refs.menuPermissions.getCheckedKeys();
      const checkedOther = this.$refs.otherPermissions.getCheckedKeys();
      const checkedPermissions = checkedMenu.concat(checkedOther);
      this.dialogPermissionLoading = true;

      userResource.updatePermission(this.currentUserId, {permissions: checkedPermissions}).then(response => {
        this.dialogPermissionLoading = false;
        this.dialogPermissionVisible = false;
      });
    },
  },
  computed: {
    userRole() {
      return 'grand_admin'
      //return this.$store.getters.roles;
    },
    normalizedMenuPermissions() {
      let tmp = [];
      this.currentUser.permissions.role.forEach(permission => {
        tmp.push({
          id: permission.id,
          name: permission.name,
          disabled: false,
        });
      });
      const rolePermissions = {
        id: -1, // Just a faked ID
        name: 'Inherited from role',
        disabled: false,
        children: this.classifyPermissions(tmp).menu,
      };

      tmp = this.menuPermissions.filter(permission => !this.currentUser.permissions.role.find(p => p.id === permission.id));
      const userPermissions = {
        id: 0, // Faked ID
        name: 'Extra menus',
        children: tmp,
        disabled: tmp.length === 0,
      };

      return [rolePermissions, userPermissions];
    },
    normalizedOtherPermissions() {
      let tmp = [];
      this.currentUser.permissions.role.forEach(permission => {
        tmp.push({
          id: permission.id,
          name: permission.name,
          disabled: false,
        });
      });
      const rolePermissions = {
        id: -1,
        name: 'По умолчанию',
        disabled: false,
        children: this.classifyPermissions(tmp).other,
      };

      tmp = this.otherPermissions.filter(permission => !this.currentUser.permissions.role.find(p => p.id === permission.id));
      const userPermissions = {
        id: 0,
        name: 'Дополнительно',
        children: tmp,
        disabled: tmp.length === 0,
      };

      return [rolePermissions, userPermissions];
    },
    userMenuPermissions() {
      return this.classifyPermissions(this.userPermissions).menu;
    },
    userOtherPermissions() {
      return this.classifyPermissions(this.userPermissions).other;
    },
    userPermissions() {
      return this.currentUser.permissions.role.concat(this.currentUser.permissions.user);
    },
  },
};
</script>
<!-- eslint-enable -->

<style lang="scss" scoped>
/* Make header clickable */
.sortable-header {
  cursor: pointer;
}

/* Hover effect */
.sortable-header:hover {
  background: rgba(0, 0, 0, 0.05);
}

/* Sort icon styles */
.sort-icon {
  font-size: 20px;
  margin-left: 8px;
}

.custom-alert {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1050;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 20px;
  max-width: 400px;
  width: 100%;
}

.alert-content {
  text-align: center;
}

.alert-buttons {
  display: flex;
  justify-content: space-around;
  margin-top: 15px;
}

.confirm-button {
  background-color: #dc3545;
  color: white;
}

.cancel-button {
  background-color: #6c757d;
  color: white;
}

/* Table styles */
.default-table-area {
  width: 100%;
  overflow-x: auto; // Allow horizontal scrolling if necessary

  .table-responsive {
    width: 100%;
    overflow-x: auto; // Ensure the table is scrollable horizontally

    .table {
      width: 100%;
      table-layout: fixed; // Ensure the table layout is fixed

      th,
      td {
        white-space: nowrap; // Prevent text from wrapping
        overflow: hidden; // Hide overflow
        text-overflow: ellipsis; // Add ellipsis for overflow text
      }

      .actions-column {
        width: 120px; // Fixed width for actions column
        text-align: center; // Center align the buttons*/
      }

      tbody {
        tr {
          td {
            ul {
              li {
                &.ms-m-15 {
                  &:first-child {
                    margin-left: 0;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

.max-width-column {
  max-width: 10px; // Set your desired maximum width
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Additional styles for clickable columns */
.clickable-column {
  cursor: pointer;
}

.clickable-column:hover {
  background: rgba(0, 0, 0, 0.05);
}

/* Ensure buttons are always visible */
.actions-column {
  button {
    margin-left: 10px;
    margin-right: -5px;
    padding: 5px 5px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
  }

  button:hover {
    opacity: 0.9;
  }
}

.sort-icon {
  font-size: 20px;
  margin-left: 8px;
}

.custom-alert {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1050;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 20px;
  max-width: 400px;
  width: 100%;
}

.alert-content {
  text-align: center;
}

.alert-buttons {
  display: flex;
  justify-content: space-around;
  margin-top: 15px;
}

.confirm-button {
  background-color: #dc3545;
  color: white;
}

.cancel-button {
  background-color: #6c757d;
  color: white;
}

.pagination .page-item.disabled .page-link {
  color: #6c757d;
  background-color: #f8f9fa;
  border-color: #dee2e6;
}

.pagination .page-item .page-link {
  color: #007bff;
  border: 1px solid #dee2e6;
  margin: 0 2px;
}

.pagination .page-item.active .page-link {
  background-color: #007bff;
  border-color: #007bff;
  color: #fff;
}

.pagination .page-item .page-link:hover {
  background-color: #e9ecef;
  border-color: #dee2e6;
}
</style>